import { render, staticRenderFns } from "./weighDialog.vue?vue&type=template&id=3a1869a4&scoped=true&"
import script from "./weighDialog.vue?vue&type=script&lang=js&"
export * from "./weighDialog.vue?vue&type=script&lang=js&"
import style0 from "./weighDialog.vue?vue&type=style&index=0&id=3a1869a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1869a4",
  null
  
)

export default component.exports